<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-bookings">
    <bpc-page-top :breadcrumb=breadcrumb :links=links></bpc-page-top>
    <bpc-page-title :heading=heading :subheading=subheading :avatar=avatar :icon=icon :actions="actions" :selection=selection :view=view>
      <b-button  class="ml-2" v-b-modal.modal-create-booking variant="success">
        <font-awesome-icon class="mr-2" icon="plus"/>Create New</b-button>
    </bpc-page-title>
    <b-card _title="Example" class="main-card mb-4">
      <bpc-table :items=items :fields=fields :selection=selection :filters=filters @update-selection="updateSelection"></bpc-table>
    </b-card>
    <b-modal id="modal-create-booking" size="lg" title="Create booking">
      <bpc-form-create-booking></bpc-form-create-booking>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="show=false">Cancel</b-button>
        <b-dropdown variant="primary" @click="show=false" right split text="Save">
          <b-dropdown-item @click="show=false">Save & Edit</b-dropdown-item>
          <b-dropdown-item>Save & New</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import BpcPageTop from '@/mockups/layouts/components/BpcPageTop.vue';
import BpcPageTitle from '@/mockups/layouts/components/BpcPageTitle.vue';
import BpcTable from '@/mockups/tables/BpcTable.vue';
import BpcFormCreateBooking from '@/mockups/forms/BpcFormCreateBooking.vue';

library.add(
  faPlus,
);

import img1 from '../../assets/resources/1.jpg';
import img2 from '../../assets/resources/2.jpg';
import img3 from '../../assets/resources/3.jpg';
import img4 from '../../assets/resources/4.jpg';
import img5 from '../../assets/resources/5.jpg';
import img6 from '../../assets/resources/6.png';
import img7 from '../../assets/resources/7.jpg';
import img8 from '../../assets/resources/8.jpg';

import avatar1 from '../../assets/avatars/1.jpg';
import avatar2 from '../../assets/avatars/2.jpg';
import avatar3 from '../../assets/avatars/3.jpg';
import avatar4 from '../../assets/avatars/4.jpg';
import avatar5 from '../../assets/avatars/5.jpg';
import avatar6 from '../../assets/avatars/6.jpg';
import avatar7 from '../../assets/avatars/7.jpg';
import avatar8 from '../../assets/avatars/8.jpg';
import avatar9 from '../../assets/avatars/9.jpg';
import avatar10 from '../../assets/avatars/10.jpg';

const items = [
  {
    id: 1,
    checked: false,
    code: '012345',
    booking_name: 'Simon Arickx',
    resource: 'Omni',
    img_url: img1,
    discipline: 'Mini Foot',
    date: '2020-03-05',
    time: '18:00 - 19:00',
    duration: 60,
    status: 'confirmed',
    payment_status: 'paid',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#3ac47d',
    price: '25,00',
  },
  {
    id: 2,
    checked: false,
    code: '012345',
    booking_name: 'Entraînement basket U12',
    resource: 'H1A',
    img_url: img5,
    discipline: 'Basket',
    date: '2020-03-05',
    time: '18:00 - 19:30',
    duration: 90,
    status: 'confirmed',
    payment_status: 'to_pay',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Club Speedy MSG' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#f7b924',
    price: '25,00',
  },
  {
    id: 3,
    checked: false,
    code: '012345',
    booking_name: 'Dickerson Macdonald',
    resource: 'T1',
    discipline: 'Tennis',
    img_url: img2,
    date: '2020-03-05',
    time: '19:00 - 20:00',
    duration: 60,
    status: 'confirmed',
    payment_status: 'paid',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar4,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#ff7514',
    price: '25,00',
  },
  {
    id: 3,
    checked: false,
    code: '012345',
    booking_name: 'Dickerson Macdonald',
    resource: 'T1',
    discipline: 'Tennis',
    img_url: img2,
    date: '2020-03-05',
    time: '19:00 - 20:00',
    duration: 60,
    status: 'cancelled',
    payment_status: 'paid',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar4,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#ff7514',
    price: '25,00',
  },
  {
    id: 3,
    checked: false,
    code: '012345',
    booking_name: 'Cours Karaté',
    resource: 'Dojo',
    discipline: 'Karaté',
    img_url: img4,
    date: '2020-03-05',
    time: '19:00 - 20:00',
    duration: 60,
    status: 'waiting',
    payment_status: 'waiting',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#2724f7',
    price: '25,00',
  },
  {
    id: 3,
    checked: false,
    code: '012345',
    booking_name: 'Dickerson Macdonald',
    resource: 'T1',
    discipline: 'Tennis',
    img_url: img3,
    date: '2020-03-05',
    time: '19:00 - 20:00',
    duration: 60,
    status: 'confirmed',
    payment_status: 'paid',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar4,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#f7b924',
    price: '25,00',
  },
  {
    id: 3,
    checked: false,
    code: '012345',
    booking_name: 'Dickerson Macdonald',
    resource: 'T1',
    discipline: 'Tennis',
    img_url: img5,
    date: '2020-03-05',
    time: '19:00 - 20:00',
    duration: 60,
    status: 'confirmed',
    payment_status: 'paid',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar4,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#f7b924',
    price: '25,00',
  },
  {
    id: 3,
    checked: false,
    code: '012345',
    booking_name: 'Dickerson Macdonald',
    resource: 'T1',
    discipline: 'Tennis',
    img_url: img5,
    date: '2020-03-05',
    time: '19:00 - 20:00',
    duration: 60,
    status: 'confirmed',
    payment_status: 'paid',
    contacts: [
      {
        id: 1,
        checked: false,
        code: '004567',
        birthdate: { date: '1979-08-24', age: 40 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Dickerson', last: 'Macdonald' },
        img_url: avatar3,
        contact_details: {
          phone: '0477/12.34.56',
          phone2: '02/123.45.67',
          email: 'info@email.com',
          email2: 'demo@admin.be',
        },
      },
      {
        id: 2,
        checked: false,
        code: '023567',
        birthdate: { date: '1998-10-15', age: 21 },
        type: 'Individual',
        status: 'active',
        name: { first: 'Larsen', last: 'Shaw' },
        img_url: avatar4,
        contact_details: {
          phone: '04/56.78.90',
          phone2: '',
          email: 'larsen.shaw@test.com',
          email2: 'demo@admin.be',
        },
      },
    ],
    color: '#f7b924',
    price: '25,00',
  },
];

const fields = [
  // 'index',
  {
    key: 'color', label: '', class: 'color',
  },
  {
    key: 'checked', label: 'Check', class: 'check',
  },
  {
    key: 'img_url', label: 'Pic', class: 'avatar',
  },
  {
    key: 'code', label: '# Ref', class: 'code', sortable: true, sortDirection: 'desc',
  },
  // {
  //   key: 'date', label: 'Date', class: 'date', sortable: true, sortDirection: 'desc',
  // },
  {
    key: 'time', label: 'Time', class: 'time', sortable: true, sortDirection: 'desc',
  },
  // {
  //   key: 'duration', label: 'Duration', class: 'duration', sortable: true, sortDirection: 'desc',
  // },
  {
    key: 'resource', label: 'Resource', class: 'resource', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'discipline', label: 'Discipline', class: 'discipline', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'booking_name', label: 'Name', class: 'name', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'contacts', label: 'Contacts', class: 'contacts relations', sortable: true, sortDirection: 'desc',
  },
  // {
  //   key: 'type', label: 'Type', class: 'type', sortable: true, sortDirection: 'desc',
  // },
  {
    key: 'status', label: 'Status', class: 'status', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'price', label: 'Price', class: 'price', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'payment_status', label: 'P. status', class: 'status', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'actions', label: 'Actions', class: 'actions',
  },
];

const filters = {
  'search': true, 
  'date_navigation': true,
  'status': true, 
  'resource': true, 
  'discipline': true,
  'more': true,
};

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    BpcPageTop,
    BpcPageTitle,
    BpcTable,
    BpcFormCreateBooking,
  },
  data: () => ({
    view: 'bookings',
    heading: 'Jeudi 05/03/2020',
    subheading: 'List of all daily bookings',
    icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
    avatar: '',
    breadcrumb: ['Dashboard', 'Bookings'],
    links: ['Help', 'Settings'],
    actions: {
      delete: true, bulk: true, new: false, edit: false, actions: true,
    },
    items,
    fields,
    selection: [],
    filters,
  }),
  methods: {
    updateSelection(selection) {
      this.selection = selection;
    },
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
</style>
